<template>
  <v-dialog v-model="show" max-width="372">
    <v-card>
      <div style="max-width: 100%; margin: 0 !important; padding-top: 32px">
        <v-btn text icon block disabled x-large>
          <v-icon style="color: #f83030 !important">$icon-circle-error</v-icon>
        </v-btn>
      </div>
      <v-card-title align="center" style="word-break: normal !important">
        Este recurso está a ser usado pelas seguintes entidades:
      </v-card-title>
      <v-card-text>
        <ul class="error-list">
          <li
            style="text-align: left"
            v-for="(entry, index) in Object.entries(errorDetails)"
            :key="'entry-' + index"
          >
            {{ getResource(entry[0]) + " (" + entry[1] + " vezes)" }}
          </li>
        </ul>
      </v-card-text>
      <v-list-item style="padding: 0 24px 12px 24px">
        <v-list-item-content>
          <v-btn
            block
            depressed
            dark
            color="#F83030"
            height="48"
            @click="closeDialog()"
            >Continuar</v-btn
          >
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.error-list {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 60%;
}
</style>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "RemoveItem",
  props: {
    show: Boolean,
    errorDetails: {},
  },
  data: () => ({}),
  methods: {
    closeDialog() {
      this.$emit("close-dialog");
    },
    getResource(key) {
      const map = new Map([
        ["competitions", "Competições"],
        ["teamPlayers", "Jogador /Equipa"],
        ["prognostics", "Prognósticos"],
      ]);
      return map.get(key);
    },
  },
  computed: {
    errorText() {
      let text =
        "Não é possivel remover este recurso porque está a ser usado. <ul>";
      for (const entry of Object.entries(this.errorDetails)) {
        text +=
          "<li>" +
          this.getResource(entry[0]) +
          " (" +
          entry[1] +
          " vezes) </li>";
      }
      text += "</ul>";
      return text;
    },
  },
});
</script>
